/**
 * ============================================================================
 * SEARCHSPRING DRAWER (CSS-Only Approach)
 * ============================================================================
 * 
 * Uses CSS to position SearchSpring sidebar as a drawer overlay.
 * No HTML manipulation - sidebar stays in original DOM location.
 * This preserves ALL SearchSpring event listeners and functionality.
 * ============================================================================
 */

(function() {
  'use strict';

  function initDrawer() {
    const drawer = document.getElementById('SearchSpringFilterDrawer');
    if (!drawer) return;

    // Simple function to open drawer (just add class)
    function openDrawer(e) {
      if (e) e.preventDefault();
      document.body.classList.add('searchspring-drawer-open');
      document.documentElement.classList.add('searchspring-drawer-open');
    }

    // Simple function to close drawer (just remove class)
    function closeDrawer(e) {
      if (e) e.preventDefault();
      document.body.classList.remove('searchspring-drawer-open');
      document.documentElement.classList.remove('searchspring-drawer-open');
    }

    // Handle open button clicks
    const openButtons = document.querySelectorAll('.js-drawer-open-searchspring-filters');
    openButtons.forEach(openButton => {
      openButton.addEventListener('click', openDrawer);
    });

    // Handle close button clicks
    const closeButton = drawer.querySelector('.js-drawer-close-searchspring');
    if (closeButton) {
      closeButton.addEventListener('click', closeDrawer);
    }

    // Close drawer when clicking backdrop (outside the sidebar)
    document.addEventListener('click', function(e) {
      if (document.body.classList.contains('searchspring-drawer-open')) {
        const sidebar = document.getElementById('searchspring-sidebar');
        
        if (sidebar) {
          // Check if click is outside the sidebar
          const clickedInsideSidebar = sidebar.contains(e.target);
          
          // Don't close if clicking the open button (would immediately close)
          const isOpenButton = e.target.closest('.js-drawer-open-searchspring-filters');
          
          // Close if clicked outside the sidebar (on backdrop)
          if (!clickedInsideSidebar && !isOpenButton) {
            closeDrawer(e);
          }
        }
      }
    });

    // Close drawer on ESC key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && document.body.classList.contains('searchspring-drawer-open')) {
        closeDrawer(e);
      }
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDrawer);
  } else {
    initDrawer();
  }

  // Retry after delay
  setTimeout(initDrawer, 2000);

})();
